import Marquee from "react-fast-marquee";

const WORDS = ["coffee", "create", "community", "make what's yours", "in the same room"];

export const EditorialMarquee = () => (
  <section className="py-10 sm:py-14 bg-ink text-oat overflow-hidden" data-testid="marquee">
    <Marquee speed={38} gradient={false} autoFill className="marquee-track">
      {WORDS.map((w, i) => (
        <span key={i} className="inline-flex items-center">
          <span className="font-display italic font-semibold lowercase text-[11vw] sm:text-[7vw] lg:text-[5.5vw] leading-none px-6 sm:px-10">
            {w}
          </span>
          <span className="text-sunbeam text-[6vw] sm:text-[3.5vw] lg:text-[2.6vw]">✳</span>
        </span>
      ))}
    </Marquee>
  </section>
);
